import { createRouter, createWebHistory } from 'vue-router';

import { useTemplateStore } from '@/stores/template';
import { useThreadStore } from '@/stores/thread';

import HomeView from '../views/home/HomeView.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/thread/:uuid',
      name: 'thread',
      component: () => import('../views/thread/ThreadView.vue')
    },
    {
      path: '/new-message',
      name: 'new-message',
      component: () => import('../views/newMessage/NewMessageView.vue')
    },
    {
      path: '/mass_emails/:massEmailUuid',
      name: 'mass-emails',
      component: () => import('../views/newMessage/NewMessageView.vue'),
      props: true
    },
    {
      path: '/templates',
      name: 'templates',
      component: () => import('../views/templates/TemplatesView.vue')
    }
  ]
});

router.afterEach((to, from) => {
  if (to.fullPath == from.fullPath) return;
  useThreadStore().resetState();
  useTemplateStore().$reset();
});

export default router;
